import {Pipe, PipeTransform} from '@angular/core';
import {StudentMeetingEventDetailsDto} from '@api/utisha-backend';
import {VideoDto} from '@api/utisha-backend/model/videoDto';

@Pipe({ name: 'videoState' })
export class VideoStatePipe implements PipeTransform {
  constructor() {
  }

  transform(value: VideoDto.StateEnum): string | undefined {
    switch(value) {
      case VideoDto.StateEnum.New: return 'New';
      case VideoDto.StateEnum.Ready: return 'Ready';
      case VideoDto.StateEnum.Converting: return 'Being Processed';
      case VideoDto.StateEnum.Error: return 'Error';
    }
    return undefined;
  }
}
